import { Routes, RouterModule } from '@angular/router';

const companyRoutes: Routes = [
];

export const CompanyExtRouter = RouterModule.forChild(companyRoutes);